import { Component, OnInit, ViewChild } from '@angular/core';
import { ConnectsService } from '../../../services/connects.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';

@Component({
  selector: 'app-local-connects',
  standalone: true,
  imports: [CommonModule,MatTableModule,
        MatSortModule, MatPaginatorModule,],
  templateUrl: './local-connects.component.html',
  styleUrl: './local-connects.component.scss',
})
export class LocalConnectsComponent implements OnInit {
  displayedColumns: string[] = [
    'name',
    'street',
    'phone',
    'email',
  
  ];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataSource: MatTableDataSource<any[]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  local: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private connects: ConnectsService) {}
  ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.connects.getLocals().subscribe((connects:any[]) => {
      this.dataSource = new MatTableDataSource(connects);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(event: Event) {console.log(event.target);
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
